import api from "@/services/api";
import { Promise } from "core-js";
import route from "@/router/index";

const BASE_URL = "/subcon/payments";

//#region state
const state = {
  subconPayments: [],
  lastFormNumber: null,
  subconPayment: {},
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async create(context, body) {
    try {
      const response = await api.post(BASE_URL, body);
      if (response.status === 200) {
        context.dispatch(
          "toast",
          { type: "success", message: "Success Saved Data" },
          { root: true }
        );
        route.push({ name: "Detail Subcon Payment", params: { id: response.data } });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getLastFormNumber(context) {
    try {
      const response = await api.get(`${BASE_URL}/form-number`);
      if (response.status === 200) {
        let num = null;
        let date = new Date();
        if (response.data === "New") {
          num = `SCP.${date.getFullYear()}.${date.getMonth() + 1}.00001`;
        } else {
          const lastNumber = response.data ? response.data.split(".")[3] : "";
          const ctx = "" + (parseInt(lastNumber) + 1);
          const end = lastNumber.substr(0, lastNumber.length - ctx.length) + ctx;
          num = `SCP.${date.getFullYear()}.${date.getMonth() + 1}.${end}`;
        }
        context.commit("SET_LAST_FORM_NUMBER", num);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getAll(context) {
    try {
      const response = await api.get(`${BASE_URL}`);

      if (response.status === 200) {
        context.commit("SET_SUBCON_PAYMENTS", response.data);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getById(context, subconPaymentId) {
    try {
      const response = await api.get(`${BASE_URL}/${subconPaymentId}`);
      // if (response.status === 200) {
      //   context.commit("SET_SUBCON_PAYMENT", response.data);
      // }
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async update(context, body) {
    try {
      const response = await api.put(`${BASE_URL}/${body.id}`, body);
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async delete(context, id) {
    try {
      const response = await api.deleted(`${BASE_URL}/${id}`);
      if (response.status === 200) {
        route.push({ name: "Subcon Payment" });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListInvoice(context, vendorId) {
    try {
      const response = await api.get(`${BASE_URL}/invoice/${vendorId}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getListInvoiceById(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/invoice/by/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getVoucherPayment(context, id) {
    try {
      const response = await api.get(`${BASE_URL}/voucher/${id}`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getChecklist() {
    try {
      const response = await api.get(`${BASE_URL}/checklist`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getApproved() {
    try {
      const response = await api.get(`${BASE_URL}/approved`);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async updateChecklist(context, items) {
    try {
      const response = await api.post(`${BASE_URL}/checklist`, items);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async updateApproved(context, data) {
    try {
      const response = await api.post(`${BASE_URL}/approved`, data.body, {
        params: { pin: data.pin },
      });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LAST_FORM_NUMBER(state, payload) {
    state.lastFormNumber = payload;
  },
  SET_SUBCON_PAYMENT(state, payload) {
    state.subconPayment = payload;
  },
  SET_SUBCON_PAYMENTS(state, payload) {
    state.subconPayments = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
